/**
 * Moving the map to its div
 */
(() => {
  const mapWrapper = document.querySelector('.branches-map-wrapper');
  const map = document.querySelector('.branchfinder_container #map');
  if (!mapWrapper || !map) return;

  mapWrapper.appendChild(map);
})();
